import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/providers';
import { ErrorBoundary } from '@/components/layout';
import { router } from './router';

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
